import { z } from 'zod';
export const LOCALES = ['en', 'ru', 'zh', 'system'];
export const CHAIN_NODE_SOURCES = ['gonka-hub', 'preset', 'custom'];
export const SettingsSchema = z.object({
    locale: z.enum(LOCALES),
    chainNodeSource: z.enum(CHAIN_NODE_SOURCES),
    customNodeUrl: z.string().url().nullable(),
    presetNodeId: z.string().nullable().default(null),
    autoLockMinutes: z.union([
        z.literal(0),
        z.literal(1),
        z.literal(5),
        z.literal(15),
        z.literal(30),
    ]),
    termsAcceptedAt: z.string().datetime().nullable(),
});
export const DEFAULT_SETTINGS = {
    locale: 'system',
    chainNodeSource: 'gonka-hub',
    customNodeUrl: null,
    presetNodeId: null,
    autoLockMinutes: 5,
    termsAcceptedAt: null,
};
const SETTINGS_KEY = 'settings';
export async function loadSettings(db) {
    const raw = await db.get('settings', SETTINGS_KEY);
    if (raw === undefined) {
        return { ...DEFAULT_SETTINGS };
    }
    const parsed = SettingsSchema.safeParse(raw);
    if (!parsed.success) {
        return { ...DEFAULT_SETTINGS };
    }
    return parsed.data;
}
export async function saveSettings(db, partial) {
    const current = await loadSettings(db);
    const merged = SettingsSchema.parse({ ...current, ...partial });
    await db.put('settings', merged, SETTINGS_KEY);
    return merged;
}
//# sourceMappingURL=settings.js.map